// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__1JwJZ","ui-modal-rise":"Modal_ui-modal-rise__UbUXc"};